import { LocalStorageService } from "ng2-webstorage";
import { Injectable } from "@angular/core";
import { environment } from '../environments/environment';
@Injectable()
export class AppConstants {
  //public firefileUrl:an
  //public  baseUrl:string;
  //public fileDownloadUrl:string;
  constructor(private localStorage: LocalStorageService) {
    // this.baseUrl= this.localStorage.retrieve('baseUrl');
    // this.fileDownloadUrl=this.localStorage.retrieve('fileUrl');
  }
  //Rdbms
  //http://betatpapischool.azurewebsites.net/api/

  public readonly fileuploadUrl: string = 'https://betatpsrilankaapischool.azurewebsites.net/api/';
  // public readonly fileuploadUrl: string = "http://tpsrilankadevschool.azurewebsites.net/api/";
  // public readonly baseUrl: string = "http://tpsrilankadevschool.azurewebsites.net/api/";

  // public readonly baseUrl: string = 'https://betatpsrilankaapischool.azurewebsites.net/api/';

   //public readonly baseUrl: string = "https://localhost:44365/api/";
   //public readonly fileuploadUrl: string = "http://localhost:44365/api/";
  // public readonly baseUrl: string = "http://localhost:63788/api/";
  // public readonly fileuploadUrl: string = "http://localhost:63788/api/";

  //MIGRATED LIVE
  // public readonly baseUrl: string = "https://talkativeparentapi-2.azurewebsites.net/api/";
  //MIGRATED DEV
  // public readonly baseUrl: string = "https://talkativeparentapi-dev.azurewebsites.net/api/";

  public readonly baseUrl: string = "https://takativeparentapi-portal.azurewebsites.net/api/";
  // public readonly baseUrl: string = "https://talkativeparentapi-dev.azurewebsites.net/api/";
      // environment.production ?
      // "https://talkativeparentapi-2.azurewebsites.net/api/" :
      // "https://takativeparentapi-portal.azurewebsites.net/api/";

  //public readonly baseUrl: string =  this.firebaseUrl;
  public readonly OneSignalUrl: string =
    "https://onesignal.com/api/v1/notifications";
  public readonly login: string = "Validate";
  public readonly logout: string = "Logout";
  public readonly countDashboardData: string = "CountDashboardData";
  public readonly noticeboardSendMessage: string =
    "PostSchoolMessage3v2Mapping2";
  public readonly getschoolMessage: string = "GetSchoolMessagesBySchoolIdV2";
  public readonly GetParentsList: string = "GetParentsList";
  public readonly GetParentsListStudentView: string = "GetParentsListStudentView";
  public readonly GetParentsBySection: string = "GetParents";
  public readonly updateParentChild: string = "UpdateParentChild";
  public readonly PostNoticeBoardMsg: string = "PostNoticeBoardMsg";
  public readonly SendNBMessageNotification: string = "PushNBNotification";
  public readonly GetSoundingBoardComments: string = "GetSBPrivateComments";
  public readonly PostSBComments: string = "PostSBPrivateComments";
  public readonly PostSBReply: string = "PostSBPrivateComments";
  public readonly GetCalendarEvent: string = "GetCalendarEvents";
  public readonly GetCalEventById: string = "GetCalendarEventsById";
  public readonly DeleteEvents: string = "DeleteCalendarEvents";
  public readonly PostForumMessages: string = "PostForumMessage";
  public readonly GetForumMessages: string = "GetForumMessage";
  public readonly GetForumMsgById: string = "GetForumMessageById";
  public readonly GetForumComment: string = "GetForumComments";
  public readonly PostForumComments: string = "PostForumComments";
  public readonly GetstandardsectionMapping: string =
    "GetStandardSectionMapping";
  public readonly GetLevelStandardSectionMappingbyBrachId: string =
    "GetLevelStandardSectionMappingbyBrachId";
    public readonly AssignTeacherToSubject: string =
    "AssignTeacherToSubject";
  public readonly getUsers: string = "SchoolUsers";
  public readonly getUserById: string = "SchoolUsers";
  //public readonly deleteUser: string = 'DeleteAppUser';
  public readonly addDepartment: string = "PostCategory";
  public readonly getDepartment: string = "GetCategory";
  public readonly deleteDepartment: string = "DeleteCategory";
  public readonly getAttendance: string = "GetAttendance";

    //Add acadamic year Dinidu Modify
    public readonly postAcadamicYear: string = 'PostAcadamicYear';
    public readonly getAcadamicYear: string = 'GetAcadamicYear';


    // jaliya
    public readonly postGradeLevel: string = 'SetGradeLevel';


   //Add Level Dinidu Modify
    public readonly postLevel: string = 'PostLevel';
    public readonly getLevels: string = 'GetLevels';
    public readonly updateLevel: string = 'UpdateLevel';
    public readonly deleteLevel: string = 'DeleteLevel';

  // public readonly uploadFile: string = 'Storage/UploadFilev2/School';
  public readonly uploadFile: string = "Storage/UploadFile/School";
  public readonly getParentList: string = "GetParentsList";
  //nb
  public readonly getNbMessageDetailsById: string = "GetSchoolMessageById";
  public readonly deleteNbMessage: string = "DeleteNBMessagesV2/school";
  //post noticeBoard message Notification

  // public readonly SendNBMessageNotification:string='PostNoticeBoardMsg';
  //sb
  //public readonly GetSoundingBoardPrivateMessage: string = 'GetSBPrivateMessagesV2d/schoold';
  public readonly GetSoundingBoardPrivateMessage: string =
    "GetSBPrivateMessagesV2/school";
  public readonly GetSBPrivateMessageById: string =
    "GetSBMessagesByIdV2/school";
  public readonly deleteSbMessage: string = "DeleteSBMessagesV2/school";
  public readonly didreadSbMsg: string =
    "UpdateSBMessageDidReadandReplied/school";
  public readonly SendSBMessageNotification: string =
    "SendSBMessagePushNotification/school";
  //calendar
  public readonly getCalendarEventList: string =
    "School_GetCalendarEvents/School";
  public readonly deleteCalendarEvent: string =
    "School_DeleteCalendarEvents/School";
  public readonly editCalendarEvent: string =
    "School_GetCalendarEventsById/School";
  public readonly postCalendarEvents: string =
    "School_PostCalendarEvents/School";
  public readonly getAllEvents: string =
    "School_GetCalendarEventsBySchoolId/School";
  public readonly postCalenderNotification: string =
    "School_PushCalendarNotifications/School";

  public readonly fileDownloadUrl: string =
    "https://yaraupload.blob.core.windows.net/upload/";
  //File Download

  //category
  public readonly getCategory: string = "GetCategory";
  public readonly postCategory: string = "PostCategory";


  public readonly GetTeacherClassSubjectList: string = 'GetTeacherClassSubjectList';
  //manage-user
  public readonly userRole: string = "Roles";
  public readonly schoolUsers: string = "SchoolUsers";
  public readonly getSchoolUserById: string = "GetSchoolUserByid";
  public readonly deleteUser: string = "DeleteSchoolUser";
  //sections
  public readonly sectionalgrade: string = "sectionalgrade";
  //ManageUser department apis
  public readonly sbaccessroles: string = 'sbaccessroles';
  public readonly UserSpecializationCategory: string = 'UserSpecializationCategory';

  // google classroom
  public readonly getSectionStudentinSubjects: string = 'getsectionstudentinsubjects';
  public readonly getTeacherClass: string = 'getAllTeacherClassandGCL';
  public readonly postApprovalClassByTeacher: string = 'addteacherclass';
  public readonly postApprovalClassDetails: string = 'getApprovalStudentsListByClass';
  public readonly getClassStatus: string = 'GetGCLClassStatus';
  public readonly getClassesSumamry: string = 'GetGCLClassSumamry';
  public readonly postGoogleClassData: string = 'addGCL';
  public readonly getGoogleClassData: string = 'getGCL';
  public readonly deleteGoogleClass: string = 'deleteGCL';
  public readonly updateGCLName: string = 'updateGCLcoursename';
  public readonly getGCLMenuStatus: string = 'GetGCLStatus';
  public readonly postVideoClass: string = 'addVideoClass';
  public readonly getVideoClass: string = 'getVideoClass';
  public readonly postGetAllGCLByClasses: string = 'getAllGCLByClasses';

  // digital analytics apis
  public readonly getDAStatus: string = 'GetDAStatus'; // for dataAnalytics tab enable
  public readonly getStudentsRC: string = 'GetStudentsRC';
  public readonly updateStudentRC: string = 'UpdateStudentRC';
  public readonly subjectsWithSemestersDropdown: string = 'SubjectsWithSemestersDropdown';
  public readonly DataAStudentsDropdowns: string = 'dataAStudentsDropdowns';
  public readonly DataASemesterDropdown: string = 'dataASemesterDropdown';
  public readonly DataAYearDropdown: string = 'dataAYearDropdown';
  public readonly DataATestDropdown: string = 'dataATestDropdown';
  public readonly getSubjectsSectionInfo: string = 'GetSubjectsSectionInfo';
  public readonly getSchoolDetailsForRC: string = 'GetSchoolDetailsForRC';
  public readonly getAveragePerformances: string = 'GetAveragePerformances';
  //Summary
  public readonly DataASubjectsDropdown: string = 'dataASubjectsDropdown';
  //Teacher
  public readonly getSubjectsSemestersInfo: string = 'GetSubjectsSemestersInfo';
  public readonly getTeacherDetails: string = 'GetTeacherDetails';
  // public readonly getTeacherStdSection: string = 'GetTeacherStdSection';
  public readonly getTeacherStandardDropdown: string = 'GetTeacherStandardDropdown';
  public readonly getTeacherSectionDropdown: string = 'GetTeacherSectionDropdown';
  public readonly getTeacherSubjectDropdown: string = 'GetTeacherSubjectDropdown';
  // public readonly getTeacherSubject: string = 'GetTeacherSubject';
  //Students
  public readonly getStudentsStandings: string = 'GetStudentsStandings';
  public readonly addGradeSection: string = "PostGradeSectionMapping";
  //Add Subjects
  public readonly postSubject: string = 'PostSubject';
  public readonly getSubjects: string = 'GetSubjects';
  public readonly updateSubject: string = 'UpdateSubject';
  public readonly deleteSubject: string = 'DeleteSubject';
  public readonly addSubjectSectionMapping: string = 'AddSubjectSectionMapping';
  public readonly showSubjectSectionMapping: string = 'ShowSubjectSectionMapping';

  //Add sub subject
  public readonly postSubSubject: string = 'PostSubSubjects';
  public readonly updateSubSubject: string = 'UpdateSubSubjects';


  //Add Semesters
  public readonly postSemesters: string = 'PostSemesters';
  public readonly getSemesters: string = 'GetSemesters';
  public readonly postSemesterYear: string = 'PostSemesterYear'
  // public readonly getSubjects: string = 'GetSubjects';
  public readonly updateSemesters: string = 'UpdateSemesters';
  public readonly removeSemester: string = 'RemoveSemester';

  //Add Tests
  public readonly postSemesterTests: string = 'PostSemesterTests';
  public readonly updateSemesterTests: string = 'UpdateSemesterTests';
  public readonly removeSemesterTest: string = 'RemoveSemesterTest';

  //testMapping
  public readonly PostTestSectionsMapping: string = 'PostTestSectionsMapping';
  public readonly getSemesterTestMapping: string = 'GetSemesterTestMapping';

  public readonly GetUserPermissions: string = 'GetUserPermissions';

  //Add course
  public readonly showCourseSectionMapping: string = 'ShowCourseSectionMapping';

}

export const googleClassroomConfig = {
  apiKey: "AIzaSyBWWIE4l0RDqNbaHXabz7ItVuTDJd-KzyM",
  clientId: '798346411699-pp0ti75ov4lj7of3eqtfle49i6362c8q.apps.googleusercontent.com',
  discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/classroom/v1/rest"],
  scope: "https://www.googleapis.com/auth/classroom.rosters https://www.googleapis.com/auth/classroom.profile.emails https://www.googleapis.com/auth/classroom.profile.photos https://www.googleapis.com/auth/classroom.courses https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/classroom.coursework.students https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.appdata https://www.googleapis.com/auth/drive.apps.readonly https://www.googleapis.com/auth/drive.metadata https://www.googleapis.com/auth/drive.scripts"

};

export const googleCREndpoints = {
  // api key for google classroom
  apiKey: 'alt=json&key=AIzaSyBWWIE4l0RDqNbaHXabz7ItVuTDJd-KzyM',

  getCourses: 'https://content-classroom.googleapis.com/v1/courses',
  postCource: 'https://content-classroom.googleapis.com/v1/courses',
  updateCourse: 'https://content-classroom.googleapis.com/v1/courses/',
  postInvite: 'https://content-classroom.googleapis.com/v1/invitations',
  postStudent: 'https://content-classroom.googleapis.com/v1/courses/115599682615/students?alt=json&key=AIzaSyBWWIE4l0RDqNbaHXabz7ItVuTDJd-KzyM',
  getCourseWork: 'https://classroom.googleapis.com/v1/courses/',
  createAssignment: 'https://content-classroom.googleapis.com/v1/courses/',
  getCourseDetail: 'https://content-classroom.googleapis.com/v1/courses/',
  deleteCourse: 'https://content-classroom.googleapis.com/v1/courses/',

  //assignment detail api's
  getAssignmentDetail: 'https://classroom.googleapis.com/v1/courses/',
  getAssignmentStudentDetail: ' https://classroom.googleapis.com/v1/courses/',
  getAssignmentSubmittionDetail: 'https://classroom.googleapis.com/v1/courses/',

  //google drive api's

  fileUploadToDrive: 'https://www.googleapis.com/upload/drive/v3/files?uploadType=media&key=AIzaSyBWWIE4l0RDqNbaHXabz7ItVuTDJd-KzyM',
  fileRenameToDrive: 'https://content.googleapis.com/drive/v2/files/',
  getDriveFileList: 'https://content.googleapis.com/drive/v3/files?',
  getFileDetail: 'https://content.googleapis.com/drive/v2/files/',
  getFolderChildList: 'https://content.googleapis.com/drive/v2/files/',
  getFileFromDrive: 'https://www.googleapis.com/drive/v2/files/',

  //google meet
  addCalendarEvent: 'https://content.googleapis.com/calendar/v3/calendars/primary/events?conferenceDataVersion=1&',

  //google report
  getReportActivity: 'https://content-admin.googleapis.com/admin/reports/v1/activity/users/all/applications/meet',
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/app.constants.ts